import {
    Avatar,
    Card,
    CardContent,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography,
    useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import FileDropZone from "./FileDropZone";
import {Fragment, useState, useEffect, useRef} from "react";
import {
  FORM_APPROVED,
  FORM_NEEDED,
  FORM_PENDING,
  FORM_REJECTED,
  statusColors,
  statusIcons,
} from "../../../store/account/constants";
import ChooseFilesButton from "./ChooseFilesButton";
import ChosenFilesList from "./ChosenFilesList";
import { useDispatch, useSelector } from "react-redux";
import {downloadSingleForm, downloadSingleSubmission} from "../../../store/account/thunks";
import LinkIcon from '@mui/icons-material/Link';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { createPortal } from "react-dom";
import { Modal, Button, Snackbar, Alert } from "@mui/material";
import axios from 'axios';
import { useSingleFormUploadMutation} from "../../../store/account/api";
import { useDropzone } from 'react-dropzone';



const CamperDocumentBox = ({ camper, files, onFileAdd }) => {
    const [showingComments, setShowingComments] = useState(false);
    const [healthFormStatus, setHealthFormStatus] = useState(null);
    const [healthFormComments, setHealthFormComments] = useState(null);
    const [documentStatuses, setDocumentStatuses] = useState({});
    const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false); // State for snackbar

    const [comments, setComments] = useState([]);
    const smallScreen = useMediaQuery("(max-width:750px)");
    const { programType } = useSelector((state) => state.account);
    const dispatch = useDispatch();
    const customerId = useSelector((state) => state.auth);
    const token = localStorage.getItem('token');
    const [
        singleFormUpload,
        {
            data: formUploadData,
            error: formUploadError,
            isSuccess: isSuccessFormUpload,
            isError: isErrorFormUpload,
        },
    ] = useSingleFormUploadMutation();


    const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: smallScreen ? "90%" : "740px",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    maxHeight: "80%",
    overflow: "auto",
  };


    useEffect(() => {
        axios.get(`/api/get_participant_health_form_info/${camper.id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => {
                setHealthFormStatus(response.data.status);
                setHealthFormComments(response.data.comments);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        const initialStatuses = {};
        camper.documentInfo.forEach(doc => {
            initialStatuses[doc.id] = doc.latestSubmissionStatus || null;
        });
        setDocumentStatuses(initialStatuses);
    }, [camper.documentInfo]);

    const handleSnackbarClose = () => {
        setOpenSuccessSnackbar(false);
    };


  const CommentsModal = () => {
    return createPortal(
      <Modal open={showingComments} onClose={() => setShowingComments(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6">Rejected Form Comments</Typography>
          <Divider />
          <List>
            {comments.map((comment, index) => (
              <ListItem key={index}>
                <ListItemText primary={comment} />
              </ListItem>
            ))}
          </List>
          <Button
            onClick={() => setShowingComments(false)}
            sx={{ marginTop: "15px" }}
          >
            OK
          </Button>
        </Box>
      </Modal>,
      document.getElementById("modal-root")
    );
  };

  function showRejectedComment() {
    setComments(getComments());
    setShowingComments(true);
  }

  //gets which C-CATS program type the camper is in (otherwise returns the programType from the Redux store)
  function getProgramType() {
    let type = programType;
    if (type.includes("C-CATS")) {
      camper.sessions.forEach((session) => {
        if (session.programType.includes("C-CATS")) {
          type = session.programType;
        }
      });
    }
    return type;
  }

  function getStatus() {
      const documentStatusesValues = Object.values(documentStatuses);
      if (healthFormStatus === 2 && documentStatusesValues.every(status => status === 'approved')) {
          return FORM_APPROVED;
      }

      if (documentStatusesValues.some(status => status === null) || healthFormStatus === 0 ) {
          return FORM_NEEDED;
      }

      if (documentStatusesValues.some(status => status === 'rejected') || healthFormStatus === 3 ) {
          return FORM_REJECTED;
      }

      if ((healthFormStatus === 1 || healthFormStatus === 2) && documentStatusesValues.every(status => status === 'pending' || status === 'approved')) {
          return FORM_PENDING;
      }

      return FORM_NEEDED;
  }

  function getComments() {
    let comments = [];
    camper.documentInfo.forEach((document) => {
      if (document.comments && document.statusDesc === FORM_REJECTED) {
        comments.push(document.comments);
      }
    });
    return comments;
  }

    const getHealthFormIcon = (status) => {
        switch (status) {
            case 1:
            case 2:
                return <CheckIcon sx={{ color: 'green' }} />;
            case 3:
                return <CloseIcon sx={{ color: 'red' }} />;
            case 0:
            case null:
                return <AccessTimeIcon sx={{ color: 'orange' }} />;
            default:
                return  <AccessTimeIcon sx={{ color: 'orange' }} />;
        }
    };

    function getDocumentListItem(document, index, boxSize) {
        const [selectedFile, setSelectedFile] = useState(null);
        const dispatch = useDispatch();
        const fileInputRef = useRef(null);
        const [documentStatus, setDocumentStatus] = useState(documentStatuses[document.id]);
        const fontSize = boxSize == "large" ? "16px" : "12px";

        const handleFileUpload = async (file) => {
            const confirmUpload = window.confirm(`Are you sure you want to upload a submission for ${document.name}? This will overwrite any previous submissions.`);
            if (confirmUpload) {
                const formData = new FormData();
                formData.append('participantFormId', document.id);
                formData.append('file', file);

                try {
                    const response = await singleFormUpload(formData).unwrap();
                    setSelectedFile(file);
                    setDocumentStatuses(prev => ({
                        ...prev,
                        [document.id]: response.status
                    }));
                    setDocumentStatus(documentStatuses[document.id])
                    setOpenSuccessSnackbar(true);
                } catch (error) {
                    console.error('Upload failed:', error);
                }
            }
        };

        const { getRootProps, getInputProps } = useDropzone({
            onDrop: (acceptedFiles) => {
                handleFileUpload(acceptedFiles[0]);
            }
        });

        const handleChooseFile = () => {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        };

        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                handleFileUpload(file);
            }
        };

        return (
             <Box key={index}>
                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '30px' }}>
                     <Typography sx={{ fontWeight: 500 }}>{document.name}</Typography>
                     {documentStatus == "pending" && <Typography
                         sx={{
                             cursor: 'pointer',
                             color: 'grey.500',
                             fontWeight: 'normal',
                             '&:hover': {
                                 color: 'grey.700',
                                 textDecoration: 'underline',
                             },
                         }}
                         onClick={handleChooseFile}
                     >
                         (Change)
                     </Typography>}
                 </Box>

                 {documentStatus == 'rejected' && document.comments != '' && (
                    <Box
                        sx={{
                            background: "#FFECB3",
                            color: "#B97200",
                            padding: "10px",
                            textAlign: "center",
                            marginY: "10px",
                            border: "1px solid #FFC107",
                            borderRadius: "4px",
                        }}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "14px" }}>
                            Rejection Notes: {document.comments}
                        </Typography>
                    </Box>
                )}
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', padding: 0 }}>
                    {/* Left side: File download */}
                    <Box
                        sx={{
                            color: "#0000EE",
                            padding: 2,
                            borderRadius: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: 'calc(50% - 2px)',
                            height: 150,
                            justifyContent: 'center',
                            cursor: 'pointer',
                            marginRight: '4px'
                        }}
                        onClick={() => {
                            // Handle file download logic here
                            dispatch(downloadSingleForm({ participantId: camper.id, programType, formId: document.form_id }));
                        }}
                    >
                        <InsertDriveFileIcon sx={{ fontSize: 40, color: 'gray' }} />
                        <Typography variant="body1" sx={{ marginTop: 2, fontSize: fontSize, textDecoration: 'underline' }}>1. Download Printable Form (PDF)</Typography>
                        {document.name.includes("NOC") && (<Typography variant="caption" sx={{ marginTop: 2, color: "#383838", textAlign: "center" }}>NOTE: The NOC waiver must be physically signed. <br/><b>Digital signatures will be rejected</b>.</Typography>)}
                    </Box>
                    {/* Right side: Upload or success state */}
                    {selectedFile || documentStatus == "pending" || documentStatus == "approved" ? (
                    // {selectedFile ? (
                        <Box
                            sx={{
                                backgroundColor: '#279D27',
                                padding: 2,
                                borderRadius: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: 'calc(50% - 2px)',
                                height: 150,
                                justifyContent: 'center',
                                color: 'white'
                            }}
                        >
                            <CheckCircleIcon sx={{ fontSize: 40 }} />
                            <Typography variant="body1" sx={{ marginTop: 2, fontSize: fontSize }}>2. Form {documentStatus == "approved" ? 'approved' : 'uploaded, pending approval'}</Typography>
                            <Typography variant="body2"
                                        onClick={() => {
                                            // Handle file download logic here
                                            dispatch(downloadSingleSubmission({ participantId: camper.id, submissionId: document.id }));
                                        }}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                        sx={{
                                            fontSize: fontSize,
                                            marginTop: "2px",
                                            '&:hover': {
                                                textDecoration: 'underline',
                                            },
                                        }}
                            >(Download Submission)</Typography>
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                        </Box>
                    ) : (
                        <Box
                            {...getRootProps()}
                            sx={{
                                border: '2px dashed #ccc',
                                padding: 2,
                                borderRadius: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                cursor: 'pointer',
                                width: 'calc(50% - 2px)',
                                height: 150,
                                justifyContent: 'center',
                                position: 'relative',
                            }}
                        >
                            <input {...getInputProps()} />
                            <CloudUploadIcon sx={{ fontSize: 40, color: 'gray' }} />
                            <Typography variant="body1" sx={{ marginTop: 2, fontSize: fontSize }}>2. Upload Completed Form</Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#FF9D00',
                                    position: 'absolute',
                                    bottom: 8,
                                    fontSize: fontSize
                                }}
                            >
                                (required)
                            </Typography>
                        </Box>
                    )}
                </Box>

                {selectedFile && (
                    <Box sx={{ marginTop: 2, textAlign: 'center' }}>
                        <Typography variant="body2">{selectedFile.name} is uploaded</Typography>
                    </Box>
                )}
            </Box>
        );
    }

    function HealthFormBox(){
        return (
            <Box sx={{ marginTop: '20px', width: '100%' }}>
                {/* Health Form Label */}
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: '10px' }}>
                    Health Form
                </Typography>
                {healthFormStatus == 3 && healthFormComments != '' && (
                    <Box
                        sx={{
                            background: "#FFECB3",
                            color: "#B97200",
                            padding: "10px",
                            textAlign: "center",
                            marginY: "10px",
                            border: "1px solid #FFC107",
                            borderRadius: "4px",
                        }}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "14px" }}>
                            Rejection Notes: {healthFormComments}
                        </Typography>
                    </Box>
                )}
                <ListItemButton
                    component={healthFormStatus === 0 || healthFormStatus === 3 ? 'a' : 'div'}
                    href={healthFormStatus === 0 || healthFormStatus === 3 ? `/participant-health-form/${camper.id}?token=${encodeURIComponent(token)}` : ''}
                    sx={{
                        border: '2px solid',
                        borderColor: healthFormStatus === 1 || healthFormStatus === 2 ? '#279D27' : '#ccc',
                        borderRadius: 1,
                        padding: '30px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        backgroundColor: healthFormStatus === 1 || healthFormStatus === 2 ? '#279D27' : 'inherit',
                        color: healthFormStatus === 1 || healthFormStatus === 2 ? '#FFFFFF' : 'inherit',
                        pointerEvents: healthFormStatus === 1 || healthFormStatus === 2 ? 'none' : 'auto',
                        position: 'relative',
                    }}
                >
                    <ListItemIcon sx={{ justifyContent: 'center', fontSize: 40 }}>
                        {healthFormStatus === 1 || healthFormStatus === 2 ? (
                            <CheckCircleIcon sx={{ fontSize: 40, color: 'white' }} />
                        ) : (
                            <LinkIcon sx={{ fontSize: 40 }} />
                        )}
                    </ListItemIcon>

                    <Typography
                        variant="body1"
                        sx={{
                            marginTop: 2,
                            ...(healthFormStatus === 0 && {
                                color: 'blue',
                                textDecoration: 'underline',
                            }),
                        }}
                    >
                        {healthFormStatus === 1
                            ? 'Health Form submitted, pending approval'
                            : healthFormStatus === 2
                                ? 'Health Form Approved'
                                : 'Click here to complete online health form'}
                    </Typography>


                    {healthFormStatus === 3 && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#FF9D00',
                                position: 'absolute',
                                bottom: 8,
                            }}
                        >
                            (updates needed)
                        </Typography>
                    )}
                </ListItemButton>

            </Box>
        )
    }

    function LargeBox() {
        return (
            <Card     sx={{
                boxShadow: "none",
                border: "none",
            }}>
                <Box
                    sx={{
                        background: "#ffffff",
                        color: "#333333",
                        marginLeft: "15px",
                        marginRight: "15px",
                        paddingTop: "10px",
                    }}
                >
                    <Grid
                        container
                        sx={{
                            display: "flex",
                            flexFlow: "row nowrap",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Grid item sx={{ margin: 0, lineHeight: 1, paddingY: 0 }}>
                            <Typography variant="h4">{camper.fullName}</Typography>
                        </Grid>
                    </Grid>
                </Box>
                {getStatus() === FORM_REJECTED && (
                    <Box
                        sx={{
                            background: "#B97200",
                            color: "white",
                            padding: "15px",
                            marginLeft: "15px",
                            marginRight: "15px",
                            textAlign: "center",
                            marginY: "4px",
                        }}
                    >
                        <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "20px" }}>
                            Form updates needed. Please see below.
                        </Typography>
                    </Box>
                )}

                <CardContent>
                        <HealthFormBox/>

                        <Box sx={{ width: "100%" }}>
                            <List>
                                {camper.documentInfo.map((document, index) => {
                                    return getDocumentListItem(document, index, 'large');
                                })}
                            </List>
                        </Box>
                    {/*</Stack>*/}
                </CardContent>
            </Card>
        );
    }

    function SmallBox() {
        return (
            <Card  sx={{
                boxShadow: "none",
                border: "none",
            }}>
                {/* Header Section */}
                <Box
                    sx={{
                        marginBottom: "4px",
                        background: "#ffffff",
                        color: "#333333",
                        marginLeft: "15px",
                        marginRight: "15px",
                        paddingY: "10px",
                        height: "65px",
                    }}
                >
                    <Grid
                        container
                        sx={{
                            display: "flex",
                            flexFlow: "row nowrap",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Grid item xs={7}>
                            <Typography variant="h4">{camper.fullName}</Typography>
                        </Grid>
                    </Grid>
                </Box>

                {/* Form Rejected Banner */}
                {getStatus() === FORM_REJECTED && (
                    <Box
                        sx={{
                            background: "#B97200",
                            color: "white",
                            padding: "15px",
                            marginLeft: "15px",
                            marginRight: "15px",
                            textAlign: "center",
                            marginBottom: "20px",
                        }}
                    >
                        <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "18px" }}>
                            Form updates needed. Please see below.
                        </Typography>
                    </Box>
                )}

                {/* Content Section */}
                <CardContent>
                    <HealthFormBox/>

                    {/* Document List Section */}
                    <Box sx={{ width: "100%" }}>
                        <List>
                            {camper.documentInfo.map((document, index) => {
                                return getDocumentListItem(document, index, 'small');
                            })}
                        </List>
                    </Box>
                </CardContent>
            </Card>
        );
    }


  return (
    <Fragment>
        <Snackbar
            open={openSuccessSnackbar}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={handleSnackbarClose} severity="success">
                Document uploaded successfully!
            </Alert>
        </Snackbar>
      <CommentsModal />
      {smallScreen ? <SmallBox /> : <LargeBox />}
    </Fragment>
  );
};

export default CamperDocumentBox;
